// In-memory cache of which emailable reports reach the user ({report id:
// bool}), so the Report Library shows its Emailed badges immediately on a
// return visit while a fresh check runs. Keyed by user so a different login
// in the same tab never sees, or changes, another user's badges; gone on
// page reload. version increases on every write; changedAt records the
// version at which a switch change set each report, so a badge request that
// started before a change can't undo it (and only that report wins).
let cache = { userKey: null, reports: null, version: 0, changedAt: {} };
// The user the Report Library is open for. A switch save that finishes after
// a different user signed in is dropped instead of taking over the cache.
let activeUserKey = null;

export function setActiveEmailedReportsUser(userKey) {
  activeUserKey = userKey ?? null;
}

export function getCachedEmailedReports(userKey) {
  return userKey != null && cache.userKey === userKey ? cache.reports : null;
}

// Read before starting a badge request; pass to storeEmailedReports.
export function emailedReportsVersion() {
  return cache.version;
}

// Stores a badge response and returns what the badges should show. Reports
// this user changed with the switch after the request started keep their
// newer value; every other report takes the response's.
export function storeEmailedReports(userKey, reports, startedAtVersion) {
  const merged = { ...reports };
  if (startedAtVersion !== undefined && cache.userKey === userKey && cache.reports) {
    Object.entries(cache.changedAt).forEach(([reportId, changedAt]) => {
      if (changedAt > startedAtVersion && reportId in cache.reports) {
        merged[reportId] = cache.reports[reportId];
      }
    });
  }
  cache = { userKey, reports: merged, version: cache.version + 1, changedAt: cache.changedAt };
  return merged;
}

// "Email me this" changed a report's status. Always recorded (even before
// the first badge response, or over another user's cache) so an in-flight
// badge request can't overwrite it.
export function updateCachedEmailedReport(userKey, reportId, emailed) {
  if (userKey == null || (activeUserKey != null && userKey !== activeUserKey)) return;
  const sameUser = cache.userKey === userKey;
  const reports = sameUser ? cache.reports || {} : {};
  const version = cache.version + 1;
  cache = {
    userKey,
    reports: { ...reports, [reportId]: Boolean(emailed) },
    version,
    changedAt: { ...(sameUser ? cache.changedAt : {}), [reportId]: version },
  };
}
